import moment from 'moment';

export default {
  name: 'CreateSchedule',
  props: {
    departmentId: {
      type: Number
    },
    divisionId: {
      type: Number
    },
    type: {
      type: String
    },
    filterData: {
      type: Object
    }
  },
  methods: {
    createSchedule () {
      const path = 'ezuro/schedule/save';
      const date = moment(new Date(this.filterData.year + '.' + this.filterData.month + '.01'));
      const data = {
        type: this.type,
        department_id: this.departmentId,
        division_id: this.divisionId,
        date_start: date.format('YYYY-MM-DD'),
        date_end: date.endOf('month').format('YYYY-MM-DD')
      };

      this.isLoading = true;

      this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, data, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else {
          this.$emit('created', response.data);
        }

        this.isLoading = false;
      });
    }
  }
}
